import { QueryClient, UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import * as Types from '@/types/bff/gql-schema';
import { SearchNonF2fDoctorsQuery } from '@/types/bff/gql-schema';
import { NonF2fDoctorVo } from '@/types/search';

import { useSearchNonF2fDoctorsQuery } from './search.gql.impl';

const useInfiniteSearchNonF2fDoctors = (
  variables: Types.SearchNonF2fDoctorsQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.SearchNonF2fDoctorsQuery, AxiosError>
) => {
  const { data, hasNextPage, isLoading, fetchNextPage } = useInfiniteQuery<Types.SearchNonF2fDoctorsQuery, AxiosError>(
    useSearchNonF2fDoctorsQuery.getKey(variables),
    ({ pageParam = variables.request.page }) => {
      return useSearchNonF2fDoctorsQuery.fetcher({
        request: {
          ...variables.request,
          page: pageParam ? pageParam : variables.request.page,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.searchNonF2fDoctors.items.length === variables.request.limit) {
          return allPages.length + 1;
        }
        return false;
      },
    }
  );

  const category =
    data?.pages.find((page) => !!page.searchNonF2fDoctors.medicalCategoryGraph)?.searchNonF2fDoctors
      .medicalCategoryGraph || null;

  return {
    category: category,
    items:
      (data?.pages.map((page) => page.searchNonF2fDoctors.items.map(parser)).flat() as Array<NonF2fDoctorVo>) || [],
    hasNextPage: hasNextPage,
    fetchNextPage: fetchNextPage,
    isLoading: isLoading,
  };
};
export default useInfiniteSearchNonF2fDoctors;

const parser = (result: SearchNonF2fDoctorsQuery['searchNonF2fDoctors']['items'][number]): NonF2fDoctorVo => {
  return {
    ...result,
  };
};

useInfiniteSearchNonF2fDoctors.prefetchQuery = async (
  queryClient: QueryClient,
  variable: Types.SearchNonF2fDoctorsQueryVariables
) => {
  await queryClient.prefetchInfiniteQuery(
    useSearchNonF2fDoctorsQuery.getKey({
      request: {
        ...variable.request,
      },
    }),
    useSearchNonF2fDoctorsQuery.fetcher({
      request: {
        ...variable.request,
      },
    })
  );
};
